<template>
    <div>
      <Header :active="active"  @navChilIndex="getnavChilIndex" />
      <img :src="top_slogan" alt="" class="banner-img">
      <div class="w1300">
        <div class="content-nav">
          <span @click="goIndex()">首页</span>> <span>搜索</span>><span>{{title}}</span>
        </div>
        <div class="box">
          <div class="list">
            <ul>
                  <li v-for="(item,index) in articleList" :key="index" @click="goInfo(item.id,item.url)">
                      <div class="li-left">{{item.title}}</div>
                      <div class="li-right">{{item.createTime  | truncate(10)}}
                          <img src="../assets/images/19.png" alt="">
                      </div>
                  </li>
              </ul>
          </div>
        </div>
        <el-pagination
              layout="prev, pager, next"
              :total="total"
              :current-page="currentPage"
              @current-change="handleCurrentChange"
              style="float: right"
              v-if="total > 10"
            >
            </el-pagination>
        
      </div>
      <Foot />
    </div>
  </template>
  <script>
  import Header from "../components/header.vue";
  import Foot from "../components/foot.vue";
  export default {
    components: {
      Header,
      Foot,
    },
    data() {
      return {
        articleList:[],
        tabList: [],
        activeId:'',
        title:'',
        children_id:'',
        total: "",
        currentPage:1,
        pageSize: 10,
        top_slogan:this.$imgUrl + localStorage.getItem('top_slogan'),
        imgUrl:this.$imgUrl,
      };
    },
    mounted() {
      let key = this.$route.params.key;
      this.list(key);
      this.title = key
    },
    methods: {
      goInfo(id,url){
        if(url !== null && url !== undefined && url !== ""){
          window.open(url);
        }else{
          this.$router.push('/searchinfo/'+id+"/"+this.title)
        }
      },
      async list(id){
        let data ={
          title:id,
          pageNum:this.currentPage,
          pageSize:this.pageSize
        }
        let res = await this.$get('/web/news/search',data)
        if(res.code == 200){
          this.articleList = res.rows
          this.total = res.total;
        }
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.list(this.children_id)
      },  
      goIndex(){this.$router.push('/')}             
    },
  };
  </script>
  <style scoped>
    .content-nav{border-bottom: solid 1px #bb030d;padding: 15px 0;font-size: 15px;margin-top: 15px;margin-bottom: 40px;}
    .content-nav span{margin-right: 10px;margin-left: 10px;color: #727272;}
    .banner-img{width: 1300px;margin: 0 auto;margin-top: 20px;display: block;}
    .box{display: flex;}
    .list,.list1{width: 100%;}
  .list ul li,.list1 ul li{display: flex;border-bottom: solid 1px #efefef;padding-bottom: 25px;margin-bottom: 35px;}
  .list ul li:hover{cursor: pointer;}
  .li-right{display: flex;font-size: 15px;color: #696969;align-items: center;}
  .li-left{ flex: 1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-right: 60px;}
  .li-right img,.right img{width: 25px;height: 25px;margin-left: 10px;}
  .img_left{width: 140px;height: 160px;} 
  .list1 .right{margin-left: 30px;display: flex;width: 100%;align-items: center;}
  .right>div {width: 90%;}
  .right .name{font-size: 17px;margin-bottom: 15px;}
  .right p{font-size: 15px;line-height: 25px;}
  .right img{margin-left: 30px;}
    .tab {
    width: 200px;
  }
  .tab ul li {
    width: 200px;
    text-align: center;
    height: 50px;
    line-height: 50px;
    margin-bottom: 30px;
    background-color: #f4f5f9;
  }
  .tab ul .active {
    background-color: #bc0404;
    color: #fff;
  }
  .tab ul li:hover {
    cursor: pointer;
  }.content-nav span:hover{cursor: pointer;}
  </style>